import PropTypes from 'prop-types';

export default function Distance({ value }) {
  return value.toFixed(1);
}

Distance.propTypes = {
  value: PropTypes.number.isRequired,
};
